import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Section from './Section'
import SectionTitle from './SectionTitle'

const BULLETS = ['marketing.report.bullet1', 'marketing.report.bullet2', 'marketing.report.bullet3']

const CheckIcon = () => (
  <svg className="h-5 w-5 text-secondary-dark flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
  </svg>
)

/**
 * The deliverable in this market is the document, so the page shows the first
 * page of the PDF the export endpoint actually produces for the demo cohort
 * (regenerated by scripts/build_marketing_report.py).
 */
const ReportSection: React.FC = () => {
  const intl = useIntl()

  return (
    <Section id="rapport" bg="bg-background">
      <SectionTitle
        title={intl.formatMessage({ id: 'marketing.report.title' })}
        subtitle={intl.formatMessage({ id: 'marketing.report.subtitle' })}
      />

      <div className="lg:grid lg:grid-cols-2 lg:gap-12 items-center">
        <div className="order-2 lg:order-1">
          <ul className="space-y-4">
            {BULLETS.map((id) => (
              <li key={id} className="flex items-start gap-3 text-base text-foreground">
                <CheckIcon />
                <FormattedMessage id={id} />
              </li>
            ))}
          </ul>

          <div className="mt-8 flex flex-wrap gap-3">
            <span className="inline-flex items-center gap-2 rounded-lg border border-border-light bg-surface px-3 py-2 text-sm font-medium text-foreground">
              <svg className="h-4 w-4 text-error" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
              </svg>
              <FormattedMessage id="marketing.report.pdfLabel" />
            </span>
            <span className="inline-flex items-center gap-2 rounded-lg border border-border-light bg-surface px-3 py-2 text-sm font-medium text-foreground">
              <svg className="h-4 w-4 text-secondary-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3.75 9.75h16.5M3.75 14.25h16.5M8.25 4.5v15m7.5-15v15M4.875 4.5h14.25c.621 0 1.125.504 1.125 1.125v12.75c0 .621-.504 1.125-1.125 1.125H4.875A1.125 1.125 0 013.75 18.375V5.625c0-.621.504-1.125 1.125-1.125z" />
              </svg>
              <FormattedMessage id="marketing.report.csvLabel" />
            </span>
          </div>
        </div>

        <div className="order-1 lg:order-2 mb-8 lg:mb-0">
          <div className="rounded-xl border border-border-light bg-surface p-2 shadow-lg">
            <img
              src="/marketing/rapport-impact.png"
              alt={intl.formatMessage({ id: 'marketing.report.imageAlt' })}
              className="w-full rounded-lg"
              width={1224}
              height={1138}
              loading="lazy"
            />
          </div>
          <p className="mt-3 text-xs text-foreground-muted">
            <FormattedMessage id="marketing.report.pdfNote" />
          </p>
        </div>
      </div>
    </Section>
  )
}

export default ReportSection
